// Module
var code = "<div class=\"landing-page-steps\" ng-transclude=\"\"></div>\n";
// Exports
module.exports = code;